<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'JournalEditorialBoards',

  metaInfo: {
    title: 'Участие в работе редакционных коллегий журналов'
  },

  data() {
    return {}
  }
}
</script>

<style scoped></style>
